import { useState } from "react";

const SEEN_KEY = "sce_disclaimer_v1";

export function disclaimerSeen(): boolean {
  try {
    return localStorage.getItem(SEEN_KEY) === "1";
  } catch {
    return true; // storage blocked → don't trap the user in a modal loop
  }
}

// First-visit life-safety framing (public-rollout requirement): this tool
// renders ensemble spaghetti, surge tiers, and genesis odds that could be
// misread as official guidance during a landfall. Shown once, dismissible,
// persisted in localStorage.
export default function WelcomeDisclaimer() {
  const [open, setOpen] = useState(() => !disclaimerSeen());
  if (!open) return null;

  const dismiss = () => {
    try { localStorage.setItem(SEEN_KEY, "1"); } catch { /* storage blocked */ }
    setOpen(false);
  };

  return (
    <div
      style={{
        position: "fixed", inset: 0, zIndex: 100, display: "flex",
        alignItems: "center", justifyContent: "center",
        background: "rgba(4,6,12,0.78)", backdropFilter: "blur(3px)",
      }}
    >
      <div
        style={{
          maxWidth: 460, margin: 16, padding: "22px 24px", borderRadius: 12,
          background: "#0e1424", border: "1px solid rgba(255,255,255,0.14)",
          color: "rgba(255,255,255,0.9)", font: "400 14px/1.55 Inter, sans-serif",
          boxShadow: "0 18px 50px rgba(0,0,0,0.6)",
        }}
      >
        <div style={{ fontSize: 30, marginBottom: 6 }}>🌀</div>
        <b style={{ fontSize: 16 }}>Storm Context Engine is an educational tool.</b>
        <p style={{ margin: "10px 0 0", color: "rgba(255,255,255,0.7)" }}>
          It visualizes model guidance, historical climatology, and experimental
          threat indices to help you <i>understand</i> hurricanes — it is{" "}
          <b>not official forecast guidance</b>.
        </p>
        <p style={{ margin: "10px 0 0", color: "rgba(255,255,255,0.7)" }}>
          For decisions that protect life and property, use the{" "}
          <a href="https://www.nhc.noaa.gov" target="_blank" rel="noreferrer" style={{ color: "#60A5FA" }}>
            National Hurricane Center
          </a>{" "}
          and your local emergency management — always.
        </p>
        <button
          onClick={dismiss}
          style={{
            marginTop: 16, width: "100%", padding: "10px 0", borderRadius: 8, cursor: "pointer",
            border: "1px solid #60A5FA", background: "rgba(96,165,250,0.22)",
            color: "white", font: "600 14px Inter, sans-serif",
          }}
        >
          Understood — take me to the storms
        </button>
        <div style={{ marginTop: 12, textAlign: "center", fontSize: 12, color: "rgba(255,255,255,0.5)" }}>
          <a href="/privacy/" target="_blank" rel="noopener" style={{ color: "inherit" }}>Privacy</a>
          {" · "}
          <a href="/terms/" target="_blank" rel="noopener" style={{ color: "inherit" }}>Terms</a>
        </div>
      </div>
    </div>
  );
}
